<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">Privacy Policy</h1>

      <div v-html="content"></div>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/api/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    this.getContent();
  }
}
</script>
